import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AlertContentData } from '@cigna/cigna-for-brokers/shell/data-access';
import { InstantAlertDialogComponent } from '../instant-alert-dialog/instant-alert-dialog.component';
import { ContactUsComponent } from '../contact-us/contact-us.component';

@Component({
  selector: 'cigna-instant-alert',
  templateUrl: './instant-alert.component.html',
  styleUrls: ['./instant-alert.component.scss'],
})
export class InstantAlertComponent implements OnInit {
  @Input() message: AlertContentData[];
  alertLength = 500;
  messageList: AlertContentData[];
  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.messageList = this.message ? this.sortAlertData(this.message) : [];
  }
  getCriticalMessage(): AlertContentData[] {
    return this.message
      ? this.message.filter((opt) => opt.category === 'warning')
      : [];
  }
  getCriticalErrorMessage(): AlertContentData[] {
    return this.message
      ? this.message.filter((opt) => opt.category === 'errormessage')
      : [];
  }
  generateMessage() {
    let alertContent: string;
    alertContent = 'Urgent Information for Brokers';
    const messageContent: AlertContentData[] = this.messageList;
    alertContent =
      messageContent.length === 1
        ? messageContent[0].body.substring(
            0,
            this.alertLength +
              this.textLength(messageContent[0].body) -
              messageContent[0].body.length,
          )
        : alertContent;
    return alertContent;
  }

  sortAlertData(message: AlertContentData[]) {
    if (message && message.length > 0) {
      return message.sort((a, b) => a.priority - b.priority);
    }
    return [];
  }
  checkForCriticalMessage() {
    let isCriticalMessage: boolean;
    // eslint-disable-next-line no-unused-expressions
    this.getCriticalMessage().length > 0
      ? (isCriticalMessage = true)
      : (isCriticalMessage = false);
    return isCriticalMessage;
  }
  checkForContactMessage() {
    let isCriticalMessage: boolean;
    // eslint-disable-next-line no-unused-expressions
    this.getCriticalErrorMessage().length > 0
      ? (isCriticalMessage = true)
      : (isCriticalMessage = false);
    return isCriticalMessage;
  }
  showReqAccessDialog(): void {
    this.dialog.open(InstantAlertDialogComponent, {
      width: '670px',
      data: this.messageList,
    });
  }
  textLength(data: string) {
    return data.replace(/<[^>]*>?/gm, '').trim().length;
  }
  showContactForm() {
    this.dialog.open(ContactUsComponent, {
      width: '60rem',
      autoFocus: false,
      disableClose: true,
    });
  }

  checkForContactUs() {
    if (this.messageList[0].contactUs) {
      return true;
    }
    return false;
  }
}
